import { Component } from '@angular/core';

import { Observable, of, throwError } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { range } from 'lodash';

import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { RSSFeed } from '../../models/rss-feed.model';
import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';
import { RSSFeedService } from '../../services/rss-feed.service';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-rss-feed-create-dialog',
    templateUrl: './rss-feed-create-dialog.component.html',
    styleUrls: ['./rss-feed-create-dialog.component.scss'],
    standalone: false
})
export class RSSFeedCreateDialogComponent extends AbstractDialogComponent {

    feed: RSSFeed = new RSSFeed();

    nameFieldErrors: { [key: string]: boolean } = {
        duplicate: false,
        empty: false
    };
    showErrors: boolean = false;
    selectedItemsLimitOption: DropdownOptionModel;

    readonly id = 'rssFeedCreateDialog';
    readonly buttonTypes = ButtonTypesEnum;
    readonly itemsLimitOptions: DropdownOptionModel[] = [
        new DropdownOptionModel('3', 3),
        new DropdownOptionModel('5', 5),
        // final option is 100, as range() end is exclusive
        ...range(10, 105, 5).map(x => new DropdownOptionModel(x.toString(), x))
    ];

    constructor(
        public coreDialogService: CoreDialogService,
        private rssFeedService: RSSFeedService
    ) {
        super(coreDialogService, 'RSSFeedCreate');
        this.selectedItemsLimitOption = this.itemsLimitOptions[0];
        this.feed.maxItems = this.selectedItemsLimitOption.value;
    }

    createFeed() {
        this.isValid$().pipe(
            switchMap((isValid) => {
                if (isValid) {
                    return this.rssFeedService.create(this.feed);
                } else {
                    throwError(() => new Error());
                }
            })
        ).subscribe(() => this.closeDialog());
    }


    isValid$(): Observable<boolean> {
        if (!this.feed.name?.trim()) {
            this.showErrors = true;
            this.nameFieldErrors.empty = true;
            return of(false);
        }

        return this.rssFeedService.isNameDuplicated$(this.feed.name).pipe(
            map(isDuplicate => {
                if (isDuplicate) {
                    this.showErrors = true;
                    this.nameFieldErrors.duplicate = true;
                    return false;
                }
                return true;
            })
        );
    }

    itemsLimitChanged(value: number) {
        this.feed.maxItems = value;
    }


    clearErrors() {
        this.showErrors = false;
    }

    cancel() {
        this.closeDialog();
    }
}
